export const REQUEST_AUTH = 'REQUEST_AUTH';
export const REQUEST_SESSION = 'REQUEST_SESSION';
export const SET_USER = 'SET_USER';

export const LOGOUT_USER = "LOGOUT_USER";
export const REQUEST_LOGOUT_USER = "REQUEST_LOGOUT_USER";